<template>
  <div id="app" :class="themeClass">

   
    <!-- Main Content -->
    <div class="px-0 py-3">
      <router-view />
    </div>
  </div>
</template>
<script>
/* global FlutterChannel */

export default {
  name: "app",
   inject: ['imgUrl'],
 data() {
    return {
      title: null,
      platform: 'generic',
      jid:null,
      temp:null
    };
  },
  computed: {
    themeClass() {
      return this.platform === 'alifpay' ? 'theme-green' : 'theme-yellow-blue';
    },
    navColorClass() {
      return this.platform === 'alifpay' ? 'bg-deep-green' : 'bg-blue';
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const p = urlParams.get('p');
    if (p) {
      this.platform = p.toLowerCase();
    }
    this.emitter.on('updateTitle', (productData) => {
      this.title = productData.title;
      this.jid= productData.id

    })
  },
  methods: {
  goBackToFlutter() {
  

   if (typeof FlutterChannel !== 'undefined') {
    FlutterChannel.postMessage('goBack Azad 11');
  } else {
    console.warn("FlutterChannel is not available");
  }
  }
}
};
</script>
<style> 

/* Generic Yellow & Blue Theme */
.theme-yellow-blue {
  --main-bg: #041381;
  --main-text: #ffffff;
}

.bg-blue {
  background-color: #191970 !important;
}

/* AlifPay Deep Green Theme */
.theme-green {
  --main-bg: #004d40;
  --main-text: #ffffff;
}

.bg-deep-green {
  background-color: #004d40 !important;
}

/* Example global usage */
body {
  background-color: var(--main-bg);
  color: var(--main-text);
}
</style>